import clsx from "classnames";
import React, { HTMLAttributes, ReactElement } from "react";

const rowDefaultProps = {
  className: "",
  noGutters: false
};

type RowBreakpointTypes = { cols?: number } | number;

export type RowProps = HTMLAttributes<HTMLDivElement> & {
  /**
   * Removes the gutter spacing between Cols as well as any added negative margins.
   */
  noGutters?: boolean;

  /**
   * The number of columns that will fit next to each other on extra small devices (<576px)
   * type -> number | { cols: number }
   */
  xs?: RowBreakpointTypes;

  /**
   * The number of columns that will fit next to each other on small devices (≥576px)
   * type -> number | { cols: number }
   */
  sm?: RowBreakpointTypes;

  /**
   * The number of columns that will fit next to each other on medium devices (≥768px)
   * type -> number | { cols: number }
   */
  md?: RowBreakpointTypes;

  /**
   * The number of columns that will fit next to each other on large devices (≥992px)
   * type -> number | { cols: number }
   */
  lg?: RowBreakpointTypes;

  /**
   * The number of columns that will fit next to each other on extra large devices (≥1200px)
   * type -> number | { cols: number }
   */
  xl?: RowBreakpointTypes;
};

function Row(props: RowProps) {
  const { children, className, noGutters, xs, sm, md, lg, xl, ...resProps } = props;
  const RowClass = clsx(!noGutters && "u-row-gutters", "u-flex u-flex-wrap", className);

  return (
    <div data-testid="qa-grid-row" className={RowClass} {...resProps}>
      {React.Children.map(children, (child) =>
        React.isValidElement(child)
          ? React.cloneElement(child as ReactElement, { noGutters, rowCols: { xs, sm, md, lg, xl } })
          : child
      )}
    </div>
  );
}

Row.defaultProps = rowDefaultProps;

export default Row;
